/* Doubled class: this overrides BaseRow, which still injects its own
   styles at runtime. styled(BaseRow) guaranteed the override won; a
   single class would depend on stylesheet order. */
.row.row {
  height: 5.2rem;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none;
  cursor: default !important;
  position: relative;
}

/* Doubled class: this overrides RowMirror, which still injects its own
   styles at runtime. styled(RowMirror) guaranteed the override won; a
   single class would depend on stylesheet order. */
.wrapper.wrapper {
  top: unset;
  bottom: 0;
  background-color: var(--color-primary-sandal);
  border-radius: 0.4rem;
  padding-left: 1.6rem;
}

.name-wrapper {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  grid-column: 1 / span 3;
}

.day-name {
  font-weight: 400;
  color: var(--color-grayscale-white, #fafafa);
  line-height: 2.4rem;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 1.6rem;
}

.center-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 1.6rem;
  justify-content: center;
}

.day-text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-grayscale-ghost, #cacdd5);
  line-height: 1.8rem;

  &:first-child {
    text-align: right;
    left: -10rem;
  }
}

.action-menu-wrapper {
  grid-column: 9 / span 1;
  padding-inline-end: 1.8rem;
  margin-left: auto;
}

.inline-time-wrapper {
  grid-column: 8 / span 1;
  padding-inline-end: 1.6rem;
  margin-inline-start: -1.2rem;
}

.dod-text {
  grid-column: 6 / span 1;
  color: var(--color-grayscale-ghost, #cacdd5);
  line-height: 1.8rem;
  text-align: left;

  @media screen and (max-width: 1130px) {
    padding-left: 0.8rem;
  }
}
